module.exports = __webpack_public_path__ + "img/m-banner-rvzldswd-ru-RU.a576788d.jpg";